/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferFromResponse,
  AccountTransferFrom: (params: vp.AccountTransferFromRequest) => void,
  reset: () => void,
  AccountTransferFrom: (params: vp.AccountTransferFromRequest) => Promise<vp.AccountTransferFromResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferFrom: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountTransferFrom, setShouldAccountTransferFrom] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferFromRequest>({
    Amount: 0,
    DebitorAccountID: '',
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
    IdempotencyKey: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferFromResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldAccountTransferFrom) return () => {};

    const PostAccountTransferFrom = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postAccountTransferFrom(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountTransferFrom) void PostAccountTransferFrom();
    setShouldAccountTransferFrom(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountTransferFrom]);

  return [
    response,
    (_params: vp.AccountTransferFromRequest) => {
      setParams(_params);
      setShouldAccountTransferFrom(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldAccountTransferFrom(false);
    },
    async (_params: vp.AccountTransferFromRequest) => {
      const res = await api.postAccountTransferFrom(_params, source);
      return res;
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferFrom);
